import { Box, styled } from '@mui/material';
import { HelixPalette, HelixStyles } from '../../../helix';
export const TimePickerInputWrapper = styled(Box)(() => ({
    height: 40,
    width: 50,
    overflow: 'hidden',
    display: 'flex',
    border: `2px solid ${HelixPalette.neutral50}`,
    borderRadius: '0.25rem',
    '&:not(&.disabled):hover': {
        borderColor: HelixPalette.teal40,
        '.stepper-buttons': {
            borderColor: HelixPalette.teal40,
        },
    },
    '&:focus-within': {
        outline: HelixStyles.focusVisible4.outline,
        outlineOffset: HelixStyles.focusVisible4.outlineOffset,
        borderColor: HelixPalette.teal50,
        '.stepper-buttons': {
            borderColor: HelixPalette.teal50,
        },
    },
    ':active:focus': {
        borderColor: HelixPalette.teal60,
    },
    '&.data-error': {
        borderColor: HelixPalette.danger,
        '.stepper-buttons': {
            borderColor: HelixPalette.danger,
        },
    },
    '&.disabled': {
        borderColor: HelixPalette.neutral30,
        backgroundColor: HelixPalette.neutral10,
        '.stepper-buttons': { borderColor: HelixPalette.neutral30 },
    },
}));
/**
 * Styled input fpr picking hrs or mins.
 */
export const TimePickerInputField = styled('input')(() => (Object.assign(Object.assign({}, HelixStyles.style_07), { lineHeight: '1rem', border: 'none', overflow: 'hidden', padding: 0, paddingRight: '20px', maxWidth: '100%', textAlign: 'center', '&:focus': { outline: 'none' }, ':disabled': { color: HelixPalette.neutral50 } })));
/**
 * Styled Box for input stepper.
 */
export const TimePickerInputStepper = styled(Box)(() => ({
    borderLeft: `2px solid ${HelixPalette.neutral50}`,
    display: 'flex',
    flexDirection: 'column',
    height: '38px',
    left: 'calc(100% - 18px)',
    overflow: 'hidden',
    position: 'absolute',
    top: 0,
    '&[data-error=true]': { borderColor: HelixPalette.danger },
}));
